import { render, staticRenderFns } from "./potentialInfo.vue?vue&type=template&id=2a3069b0&scoped=true"
import script from "./potentialInfo.vue?vue&type=script&lang=js"
export * from "./potentialInfo.vue?vue&type=script&lang=js"
import style0 from "./potentialInfo.vue?vue&type=style&index=0&id=2a3069b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3069b0",
  null
  
)

export default component.exports